export default class UrlHelper {
    static join = (url, str) => {
        if (url.endsWith("/") && str.startsWith("/")) {
            return url + str.substring(1, str.length);
        }

        if (!url.endsWith("/") && str.startsWith("/")) {
            return url + str;
        }

        if (url.endsWith("/") && !str.startsWith("/")) {
            return url + str;
        }

        if (!url.endsWith("/") && !str.startsWith("/")) {
            return url + "/" + str;
        }
    }

}